import React, { useState, useContext } from 'react'
import RegisterWatcher from '../Watcher/RegisterWatcher'
import LoginPopup from './LoginPopup'
import LiveContext from '../../components/Context/LiveContext'

function Login() {
  const [isRegisterOpened, setRegisterOpened] = useState(false)
  const { isLoginOpened, toggleLoginOpened } = useContext(LiveContext)

  const handleCreateAccount = () => {
    toggleLoginOpened(false)
    setRegisterOpened(true)
  }

  const handleRegisterClose = () => {
    setRegisterOpened(false)
  }

  const handleSubmitRegister = () => {
    toggleLoginOpened(true)
    setRegisterOpened(false)
  }

  const handleLoginClose = () => {
    toggleLoginOpened(false)
  }

  return (
    <div>
      <LoginPopup
        isOpened={isLoginOpened}
        onClose={handleLoginClose}
        onCreateAccount={handleCreateAccount}
      />
      <RegisterWatcher
        isOpened={isRegisterOpened}
        onClose={handleRegisterClose}
        onReturn={() => {
          toggleLoginOpened(true)
          handleRegisterClose()
        }}
        onSubscription={handleSubmitRegister}
      />
    </div>
  )
}

export default Login
